import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { getTenant } from '@ovpn-ui-toolkit/mf-common';
import { setupRequestInterceptor, ErrorBoundary } from '@cloud/shared';

import configureStore from './store/configureStore';
import App from './App';

const store = configureStore({
    devToolsName: 'cloud-nav',
    sagaOptions: {
        context: {
            tenant: getTenant(),
        },
    },
});

setupRequestInterceptor(store);

function Root() {
    return (
        <ErrorBoundary>
            <Provider store={store}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </Provider>
        </ErrorBoundary>
    );
}

export default Root;
